export default __webpack_public_path__ + "static/media/kitchen-5.80cf16cd.jpg";